import { c as components } from "../../../chunks/component-client-DyWNs_W1.mjs";
const sheet = components.sheetV1;
const open = sheet.open;
const close = sheet.close;
const back = sheet.back;
const create = sheet.create;
const getOpenSheet = sheet.getOpenSheet;
const getHeader = sheet.getHeader;
const getContent = sheet.getContent;
const getActions = sheet.getActions;
const events = sheet.events;
const openEvent = sheet.openEvent;
const closeEvent = sheet.closeEvent;
const contentLoadedEvent = sheet.contentLoadedEvent;
const contentLoadingErrorEvent = sheet.contentLoadingErrorEvent;
export {
  back,
  close,
  closeEvent,
  contentLoadedEvent,
  contentLoadingErrorEvent,
  create,
  events,
  getActions,
  getContent,
  getHeader,
  getOpenSheet,
  open,
  openEvent,
  sheet
};
//# sourceMappingURL=index-client.mjs.map
